import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {

  const navigate = useNavigate();

  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const login = async () => {

    if (!username || !password) {

      alert("Enter Username & Password");

      return;

    }

    try {

      setLoading(true);

      const res = await fetch("/api/admin-auth/login", {

        method: "POST",

        headers: {

          "Content-Type": "application/json",

        },

        body: JSON.stringify({

          username,

          password,

        }),

      });

      const data = await res.json();

      if (!data.success) {

        alert(data.message);

        setLoading(false);

        return;

      }

      localStorage.setItem(

        "adminToken",

        data.token

      );

      navigate("/admin/dashboard");

    } catch (err) {

      alert(err.message);

    }

    setLoading(false);

  };

  return (

    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#0f172a",
      }}
    >

      <div
        style={{
          width: 380,
          background: "#1e293b",
          padding: 35,
          borderRadius: 12,
          color: "#fff",
        }}
      >

        <h2 style={{ textAlign: "center" }}>

          Admin Login

        </h2>

        <input

          placeholder="Username"

          value={username}

          onChange={(e) =>

            setUsername(e.target.value)

          }

          style={{

            width: "100%",

            padding: 12,

            marginTop: 20,

          }}

        />

        <input

          type="password"

          placeholder="Password"

          value={password}

          onChange={(e) =>

            setPassword(e.target.value)

          }

          style={{

            width: "100%",

            padding: 12,

            marginTop: 15,

          }}

        />

        <button

          onClick={login}

          style={{

            width: "100%",

            marginTop: 20,

            padding: 12,

            background: "#2563eb",

            color: "#fff",

            border: 0,

            cursor: "pointer",

            fontSize: 18,

          }}

        >

          {loading ? "Please Wait..." : "LOGIN"}

        </button>

      </div>

    </div>

  );

}
